import React, { ReactElement } from 'react';
import styles from '../styles.module.css';
import { CreateAnAccount } from '../../components/auth/SignUp';

const SignUpPage = (): ReactElement => (
  <div className={styles.auth_container}>
    <CreateAnAccount />
  </div>
);

export default SignUpPage;
